export type BillingMethod = 'EMAIL' | 'POST';
export type ConnectionScenario =
  | 'CUST_MOVE'
  | 'PROS_SWT'
  | 'CUST_MOUT'
  | 'PROS_MOVE'
  | 'CUST_SWT'
  | 'CUST_PRCH'
  | 'CUST_VC'
  | 'PROS_VC'
  | 'ACC_TRF';
export type CustomerType = 'residential' | 'business';
export type CustomerTypeId = '0001' | '0002';
export type CustomerTypeLabels = 'RESIDENTIAL' | 'BUSINESS';
export type DivisionId = '01' | '02' | '03' | '90' | 'SO' | 'OHM';
export type DivisionIdLabels = 'ELECTRICITY' | 'GAS' | 'HOT_WATER' | 'LPG' | 'SOLAR' | 'OHM';

export type EligibilityStatus = '00' | '01' | '02' | '03' | '04' | '05';
export type FuelType =
  | 'electricity'
  | 'embedded_electricity'
  | 'gas'
  | 'hot water'
  | 'lpg'
  | 'dual';
export type FuelTypeLabels =
  | 'ELECTRICITY'
  | 'EMBEDDED_ELECTRICITY'
  | 'GAS'
  | 'HOT_WATER'
  | 'LPG'
  | 'DUAL';

export type BillFrequencyId = 'OM' | 'BM' | 'Q';

export type BillFrequencyDescription = 'Monthly' | 'Bi-Monthly' | 'Quarterly';
export interface IBillFrequencyOption {
  billFrequencyId: BillFrequencyId;
  billFrequencyDescription: BillFrequencyDescription;
}

export type STATE = 'ACT' | 'VIC' | 'NSW' | 'QLD' | 'WA' | 'SA' | 'NT' | 'TAS';
export type IAvailabilityStatus = 'EVERYONE' | 'RESTRICTED';

export const FUEL_TYPE: { [K in FuelTypeLabels]: FuelType } = {
  DUAL: 'dual',
  ELECTRICITY: 'electricity',
  GAS: 'gas',
  HOT_WATER: 'hot water',
  LPG: 'lpg',
  EMBEDDED_ELECTRICITY: 'embedded_electricity',
};
